<svg
    xmlns="http://www.w3.org/2000/svg"
    {...$$props}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
>
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.99999 2L9 8.79289L10.8333 6.95956L11.5404 7.66667L8.49999 10.7071L5.45956 7.66667L6.16667 6.95956L8 8.7929L7.99999 2L8.99999 2ZM3.5 9.33333V12.8333C3.5 12.9254 3.57462 13 3.66667 13H13.3333C13.4254 13 13.5 12.9254 13.5 12.8333V9.33333H14.5V12.8333C14.5 13.4777 13.9777 14 13.3333 14H3.66667C3.02233 14 2.5 13.4777 2.5 12.8333V9.33333H3.5Z"
        fill="#3643BA"
    />
</svg>
